export default __webpack_public_path__ + "static/media/agresivo.25565314.png";